import React, { useState } from 'react';
import { m, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { faqs } from '../../data/content';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-10 sm:py-14" data-id="element-37" data-mp="2z2fgzb7836nm">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-38" data-mp="2z5bg32ut41dn">
        <div className="text-center" data-id="element-39" data-mp="3mtun7f24e845">
          <SectionTag data-id="element-40" data-mp="3muw8eccuoazl">Preguntas Frecuentes</SectionTag>
        </div>

        <div className="mt-8 space-y-3" data-id="element-41" data-mp="3rql23z26uxnz">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-navy/10 bg-cream" data-id="element-42" data-mp="3i234fqp7h6ok" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-orange" aria-expanded={isOpen} data-id="element-43" data-mp="9m9ope2p7z8k">
                  <span className="font-heading text-sm font-semibold text-navy sm:text-base" data-id="element-44" data-mp="1vs5i64btoxfe">{faq.q}</span>
                  <ChevronDownIcon size={18} className={`flex-shrink-0 text-orange-hover transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-45" data-mp="2ah1jzjnade7k" />
                </button>
                <AnimatePresence initial={false} data-id="element-46" data-mp="2eidfg5suctno">
                  {isOpen && <m.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-47" data-mp="2ekhlataaw2ql">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-muted" data-id="element-48" data-mp="z37jib0ycfcy">{faq.a}</p>
                    </m.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}